<script setup lang="ts">
import type { TabsListProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';
import { TabsList, useForwardProps } from 'reka-ui';

const props = defineProps<TabsListProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');
const forwarded = useForwardProps(delegatedProps);
</script>

<template>
  <TabsList
    v-bind="forwarded"
    :class="cn('relative flex h-9 items-center gap-1 self-stretch rounded-lg bg-gray-200', props.class)"
  >
    <slot />
  </TabsList>
</template>
